/* eslint-disable prettier/prettier */
import React from 'react'
import { Global, css } from '@emotion/react'

const getStyles = ({ hasStoredCards, forceExpiryDateErrorUIFix }) => {
  return hasStoredCards
    ? css`
        /* Disable button effect */
        button.adyen-checkout__payment-method__header__title {
          outline: none !important;
          cursor: default !important;
          max-height: unset !important;
        }
        button.adyen-checkout__payment-method__header__title:active {
          border-style: hidden !important;
        }

        /* Top label */
        .adyen-checkout-payment-methods-list-label {
          display: none !important;
        }

        /* Box styles override */
        .adyen-checkout__payment-method {
          background-color: transparent !important;
          border: unset !important;
          margin: 0 !important;
        }

        /* Hide card holder name. It's injected by js code */
        .adyen-checkout__payment-method__name {
          display: none !important;
        }

        /* Align brand icon to top */
        .adyen-checkout__payment-method__header__title {
          align-items: flex-start !important;
        }

        /* Hide delete buton. It's injected by other one in a diferent location */
        .adyen-checkout__button.adyen-checkout__button--link {
          display: none !important;
        }

        /* Hide exp date input */
        .adyen-checkout__field.adyen-checkout__field--storedCard:not(
            .adyen-checkout__field--securityCode
          ) {
          display: none !important;
        }

        /* Hide security code */
        .adyen-checkout__card-input.adyen-checkout__card-input--credit {
          display: none !important;
        }

        /* Paddings */
        .adyen-checkout__payment-method__header {
          padding-left: 32px !important;
          padding-right: 32px !important;
        }
        .adyen-checkout__payment-method__disable-confirmation__content {
          padding-left: 32px !important;
          padding-right: 32px !important;
        }

        /* Confirmation message/exp date area */
        .adyen-checkout__payment-method__disable-confirmation {
          background-color: #c73636 !important;
        }
        .adyen-checkout__payment-method__disable-confirmation.adyen-checkout__payment-method__disable-confirmation--open {
          max-height: unset !important;
        }
        .adyen-checkout__payment-method__disable-confirmation__button {
          background-color: #c73636 !important;
        }
        .adyen-checkout__payment-method__expired-msg {
          background-color: #c73636 !important;
          color: #fff !important;
          font-size: 0.81em !important;
          padding: 8px 32px !important;
          margin: 0 -17px !important;
        }
      `
    : // New Credit Card Form - Refactored
      css`
        /* Adyen text/icons hidden */
        .adyen-checkout-contextual-text,
        .adyen-checkout-form-instruction,
        .adyen-checkout__payment-method__header,
        .adyen-checkout__payment-method__header__title,
        .adyen-checkout__card__cvc__hint,
        .adyen-checkout__field__exp-date_hint {
          display: none !important;
        }

        /* Adyen Validation Icon */
        .adyen-checkout-input__inline-validation {
          position: absolute !important;
          right: 30px !important;
        }

        /* Adyen Payment Container */
        .adyen-checkout__payment-method {
          background-color: transparent !important;
          border: unset !important;
          margin: 0 !important;
        }
        .adyen-checkout__payment-method__details {
          display: block;
          padding: 28px 32px 0 !important;
        }
        .adyen-checkout__payment-method__header {
          padding: 0 !important;
        }
        .adyen-checkout__payment-method__details__content {
          margin-bottom: 4px !important;
        }

        /* Adyen Input Control */
        .adyen-checkout__input {
          height: 48px !important;
          font-size: 16px !important;
          color: #34303d !important;
          padding: 5px 16px !important;
        }
        .adyen-checkout__input-wrapper {
          border-radius: 2px !important;
          box-shadow: none !important;
          border-color: #b3b3b3 !important;
        }
        .adyen-checkout__field {
          min-height: 120px !important;
          margin-bottom: 0 !important;
        }
        .adyen-checkout__field-wrapper {
          width: 100%;
        }
        .adyen-checkout__field-wrapper > .adyen-checkout__field:nth-of-type(2) {
          margin-left: 0 !important;
        }
        .adyen-checkout__field-wrapper > .adyen-checkout__field:first-of-type {
          margin-right: 0 !important;
        }
        .adyen-checkout__label__text {
          color: #34303d !important;
          font-size: 14px !important;
          letter-spacing: 0.4px;
          padding-bottom: 14px !important;
          margin-bottom: 0 !important;
        }

        /* Adyen Input Padding */
        .adyen-checkout__field--cardNumber .adyen-checkout__input {
          padding-right: 46px !important;
        }
        .adyen-checkout__field--securityCode .adyen-checkout__input {
          padding-right: 46px !important;
        }
        .adyen-checkout__input.adyen-checkout__input--small.adyen-checkout__card__exp-date__input {
          height: 48px !important;
          font-size: 16px !important;
          color: #34303d !important;
          padding: 5px 46px 5px 16px !important;
        }

        /* Adyen Width and position fix */
        .adyen-checkout__field.adyen-checkout__field--expiryDate {
          width: 47%;
        }
        .adyen-checkout__field.adyen-checkout__field--securityCode {
          width: 49%;
        }
        .adyen-checkout__field.adyen-checkout__card__holderName {
          margin-top: 0px !important;
          display: flex !important;
          flex-direction: column !important;
        }

        /* Adyen input alignment fix */
        .adyen-checkout__card__brands {
          position: relative !important;
          top: -20px !important;
        }
        .adyen-checkout__card__brands--hidden {
          min-height: unset !important;
          max-height: unset !important;
        }

        /* Adyen Media Queries */
        @media (max-width: 1207px) {
          .adyen-checkout__field {
            min-height: 130px !important;
          }
          .adyen-checkout__card__brands {
            width: 47% !important;
            flex-wrap: nowrap !important;
            margin-top: -24px !important;
            min-height: 0 !important;
          }
          .adyen-checkout__card__brands__brand-wrapper {
            height: auto !important;
          }
          .adyen-checkout__card__exp-cvc.adyen-checkout__field-wrapper {
            margin-top: 15px !important;
            margin-bottom: 15px !important;
          }
          .adyen-checkout__field.adyen-checkout__card__holderName {
            margin-bottom: 15px !important;
            bottom: -15px !important;
          }
        }
        @media (max-width: 480px) {
          .adyen-checkout__field.adyen-checkout__field--securityCode {
            position: absolute;
            right: 0;
          }
          .adyen-checkout__field.adyen-checkout__card__holderName {
            margin-top: 30px !important;
          }
        }
        @media (min-width: 480px) {
          .adyen-checkout__field.adyen-checkout__field--expiryDate {
            position: absolute;
            top: 0;
            right: 0;
          }
          .adyen-checkout__field.adyen-checkout__card__holderName {
            width: 47%;
            position: absolute;
            bottom: 0px;
            right: 0;
            margin-top: 30px !important;
          }
          .adyen-checkout__field.adyen-checkout__field--cardNumber {
            min-height: ${forceExpiryDateErrorUIFix
              ? forceExpiryDateErrorUIFix + 'px'
              : 'unset'};
            width: 49%;
          }
        }
        @media (max-width: 390px) {
          .adyen-checkout__input {
            padding-left: 8px !important;
          }
          .adyen-checkout__input.adyen-checkout__input--small.adyen-checkout__card__exp-date__input {
            padding: 5px 56px 5px 8px !important;
          }
          .adyen-checkout__field--securityCode .adyen-checkout__input {
            padding-right: 56px !important;
          }
          .adyen-checkout__icon {
            margin: 0 3px !important;
          }
        }

        /* Adyen Card brand and Error message overlapping fix */
        .adyen-checkout__card__brands {
          z-index: 1;
          position: relative;
        }
        .adyen-checkout-contextual-text--error {
          z-index: -1;
          position: relative;
          background-color: transparent !important;
        }
        .adyen-checkout-contextual-text--error:not([hidden]) {
          z-index: 2;
          background-color: #fffdfb !important;
          padding: 3px;
        }

        /* Placeholder Compatibility  */
        .adyen-checkout__input::-webkit-input-placeholder {
          color: #7b7881 !important;
          font-size: 16px !important;
        }
        .adyen-checkout__input::-moz-placeholder {
          color: #7b7881 !important;
          font-size: 16px !important;
        }
        .adyen-checkout__input:-ms-input-placeholder {
          color: #7b7881 !important;
          font-size: 16px !important;
        }
        .adyen-checkout__input:-moz-placeholder {
          color: #7b7881 !important;
          font-size: 16px !important;
        }
        .adyen-checkout__input:placeholder-shown {
          font-weight: 200 !important;
        }

        /* Adyen Brand Icon change on type */
        .adyen-checkout__card__cardNumber__brandIcon[alt='card'] {
          display: none !important;
        }
        .adyen-checkout__card__cardNumber__brandIcon {
          z-index: 2;
          border: 1px solid #34303d !important;
        }

        /* Default icons */
        .adyen-checkout__card__cardNumber__input:before {
          z-index: 1;
          content: '\\e81e';
          opacity: 1 !important;
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          right: 12px;
          font-size: 24px;
          height: 24px;
          font-family: 'nbw-icons';
          font-style: normal;
          font-weight: 400;
          speak: never;
          text-decoration: inherit;
          width: 1em;
          text-align: center;
          font-variant: normal;
          text-transform: none;
          line-height: 1em;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        .adyen-checkout__card__cvc__input:before {
          content: '\\e827';
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          right: 12px;
          font-size: 24px;
          height: 24px;
          font-family: 'nbw-icons';
          font-style: normal;
          font-weight: 400;
          speak: never;
          text-decoration: inherit;
          width: 1em;
          text-align: center;
          font-variant: normal;
          text-transform: none;
          line-height: 1em;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        .adyen-checkout__field__exp-date_hint_wrapper::before {
          content: '\\e81c';
          display: block !important;
          position: absolute;
          margin: -12px;
          top: 0;
          bottom: 0;
          right: 12px;
          font-size: 24px;
          height: 24px;
          font-family: 'nbw-icons';
          font-style: normal;
          font-weight: 400;
          speak: never;
          text-decoration: inherit;
          width: 1em;
          text-align: center;
          font-variant: normal;
          text-transform: none;
          line-height: 1em;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* Override --hidden class */
        .adyen-checkout__field__exp-date_hint_wrapper--hidden {
          opacity: 1 !important;
        }

        /* Adyen Icon color change */
        .adyen-checkout__input.adyen-checkout__input--large.adyen-checkout__card__cardNumber__input::before {
          color: #34303d !important;
        }
        .adyen-checkout__input.adyen-checkout__input--small.adyen-checkout__card__cvc__input {
          color: #34303d !important;
        }
      `
}

const AdyenCheckoutStyleOverride = props => <Global styles={getStyles(props)} />

export default AdyenCheckoutStyleOverride
